// ============================================================
// DATA PAKET PERJALANAN PRIVAT — contoh paket yang sepenuhnya
// dapat dikustomisasi. Edit konten di sini untuk memperbarui situs.
// ============================================================

export const packages = [
  {
    id: 'singapore-malaysia',
    name: { id: 'Perjalanan Privat Singapura–Malaysia', en: 'Singapore–Malaysia Private Journey' },
    destination: { id: 'Singapura & Malaysia', en: 'Singapore & Malaysia' },
    destinationSlug: 'singapore',
    duration: { id: '5 hari 4 malam', en: '5 days 4 nights' },
    groupSize: { id: '2–8 orang', en: '2–8 people' },
    image: 'https://images.unsplash.com/photo-1628221680019-f28a2716e727?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxzaW5nYXBvcmUlMjBtYXJpbmElMjBiYXl8ZW58MHx8fHwxNzkxODc1MDYxfDA&ixlib=rb-4.1.0&q=85',
    itinerary: [
      { id: 'Hari 1–2: Singapura — Marina Bay, Gardens by the Bay, Sentosa.', en: 'Days 1–2: Singapore — Marina Bay, Gardens by the Bay, Sentosa.' },
      { id: 'Hari 3: Perjalanan darat privat ke Malaka via Johor.', en: 'Day 3: Private overland journey to Malacca via Johor.' },
      { id: 'Hari 4–5: Kuala Lumpur — Petronas Towers, Batu Caves, Genting.', en: 'Days 4–5: Kuala Lumpur — Petronas Towers, Batu Caves, Genting.' },
    ],
    attractions: [
      { id: 'Gardens by the Bay', en: 'Gardens by the Bay' },
      { id: 'Petronas Twin Towers', en: 'Petronas Twin Towers' },
      { id: 'Jonker Street, Malaka', en: 'Jonker Street, Malacca' },
    ],
    included: [
      { id: 'Kendaraan privat + sopir sepanjang perjalanan', en: 'Private vehicle + driver throughout' },
      { id: 'Hotel bintang 4 (termasuk sarapan)', en: '4-star hotels (breakfast included)' },
      { id: 'Itinerari personal & pendampingan via WhatsApp', en: 'Personal itinerary & WhatsApp assistance' },
    ],
    excluded: [
      { id: 'Tiket pesawat', en: 'Flights' },
      { id: 'Tiket masuk atraksi & makan di luar program', en: 'Attraction tickets & meals outside the program' },
      { id: 'Pengeluaran pribadi', en: 'Personal expenses' },
    ],
  },
  {
    id: 'bangkok-pattaya',
    name: { id: 'Tur Privat Bangkok–Pattaya', en: 'Bangkok–Pattaya Private Tour' },
    destination: { id: 'Thailand', en: 'Thailand' },
    destinationSlug: 'thailand',
    duration: { id: '5 hari 4 malam', en: '5 days 4 nights' },
    groupSize: { id: '2–10 orang', en: '2–10 people' },
    image: 'https://images.unsplash.com/photo-1582468546235-9bf31e5bc4a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHx0aGFpbGFuZCUyMHRlbXBsZXxlbnwwfHx8fDE3OTE4NzUwNjF8MA&ixlib=rb-4.1.0&q=85',
    itinerary: [
      { id: 'Hari 1–2: Bangkok — Grand Palace, Wat Pho, dinner cruise Chao Phraya.', en: 'Days 1–2: Bangkok — Grand Palace, Wat Pho, Chao Phraya dinner cruise.' },
      { id: 'Hari 3: Floating market, lalu transfer privat ke Pattaya.', en: 'Day 3: Floating market, then private transfer to Pattaya.' },
      { id: 'Hari 4–5: Coral Island, Sanctuary of Truth, kembali ke Bangkok.', en: 'Days 4–5: Coral Island, Sanctuary of Truth, return to Bangkok.' },
    ],
    attractions: [
      { id: 'Grand Palace', en: 'Grand Palace' },
      { id: 'Coral Island (Koh Larn)', en: 'Coral Island (Koh Larn)' },
      { id: 'Sanctuary of Truth', en: 'Sanctuary of Truth' },
    ],
    included: [
      { id: 'Kendaraan privat + sopir', en: 'Private vehicle + driver' },
      { id: 'Hotel bintang 4 di Bangkok & Pattaya', en: '4-star hotels in Bangkok & Pattaya' },
      { id: 'Dinner cruise Chao Phraya', en: 'Chao Phraya dinner cruise' },
    ],
    excluded: [
      { id: 'Tiket pesawat', en: 'Flights' },
      { id: 'Aktivitas watersport opsional', en: 'Optional watersports' },
      { id: 'Asuransi perjalanan', en: 'Travel insurance' },
    ],
  },
  {
    id: 'danang-hoian',
    name: { id: 'Perjalanan Da Nang–Hoi An, Vietnam', en: 'Vietnam Da Nang–Hoi An Journey' },
    destination: { id: 'Vietnam', en: 'Vietnam' },
    destinationSlug: 'vietnam',
    duration: { id: '5 hari 4 malam', en: '5 days 4 nights' },
    groupSize: { id: '2–8 orang', en: '2–8 people' },
    image: 'https://images.unsplash.com/photo-1643029891412-92f9a81a8c16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHx2aWV0bmFtJTIwaGElMjBsb25nJTIwYmF5fGVufDB8fHx8MTc5MTg3NTA2MXww&ixlib=rb-4.1.0&q=85',
    itinerary: [
      { id: 'Hari 1: Tiba di Da Nang, Pantai My Khe.', en: 'Day 1: Arrive in Da Nang, My Khe Beach.' },
      { id: 'Hari 2: Ba Na Hills — Golden Bridge & French Village.', en: 'Day 2: Ba Na Hills — Golden Bridge & French Village.' },
      { id: 'Hari 3–4: Hoi An — kota tua, kelas lampion, basket boat.', en: 'Days 3–4: Hoi An — ancient town, lantern class, basket boat.' },
      { id: 'Hari 5: Waktu bebas, lalu kembali.', en: 'Day 5: Free time, then return.' },
    ],
    attractions: [
      { id: 'Golden Bridge', en: 'Golden Bridge' },
      { id: 'Kota Tua Hoi An', en: 'Hoi An Ancient Town' },
      { id: 'Pantai My Khe', en: 'My Khe Beach' },
    ],
    included: [
      { id: 'Kendaraan privat + sopir lokal', en: 'Private vehicle + local driver' },
      { id: 'Hotel/resor bintang 4', en: '4-star hotels/resorts' },
      { id: 'Kelas membuat lampion tradisional', en: 'Traditional lantern-making class' },
    ],
    excluded: [
      { id: 'Tiket pesawat', en: 'Flights' },
      { id: 'Makan siang & malam di luar program', en: 'Lunches & dinners outside the program' },
      { id: 'Pengeluaran pribadi', en: 'Personal expenses' },
    ],
  },
  {
    id: 'tokyo-osaka-kyoto',
    name: { id: 'Tur Privat Tokyo–Osaka–Kyoto', en: 'Tokyo–Osaka–Kyoto Private Tour' },
    destination: { id: 'Jepang', en: 'Japan' },
    destinationSlug: 'japan',
    duration: { id: '7 hari 6 malam', en: '7 days 6 nights' },
    groupSize: { id: '2–6 orang', en: '2–6 people' },
    image: 'https://images.unsplash.com/photo-1580639613257-5b1a20fe3760?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxqYXBhbiUyMGt5b3RvJTIwc3RyZWV0fGVufDB8fHx8MTc5MTg3NTA2MXww&ixlib=rb-4.1.0&q=85',
    itinerary: [
      { id: 'Hari 1–3: Tokyo — Asakusa, Shibuya, dan day trip Gunung Fuji.', en: 'Days 1–3: Tokyo — Asakusa, Shibuya, and a Mount Fuji day trip.' },
      { id: 'Hari 4–5: Kyoto — Fushimi Inari, Arashiyama, Gion dengan kimono.', en: 'Days 4–5: Kyoto — Fushimi Inari, Arashiyama, Gion in kimono.' },
      { id: 'Hari 6–7: Osaka — kastil, Dotonbori, dan belanja.', en: 'Days 6–7: Osaka — castle, Dotonbori, and shopping.' },
    ],
    attractions: [
      { id: 'Gunung Fuji', en: 'Mount Fuji' },
      { id: 'Fushimi Inari Shrine', en: 'Fushimi Inari Shrine' },
      { id: 'Dotonbori, Osaka', en: 'Dotonbori, Osaka' },
    ],
    included: [
      { id: 'Tiket Shinkansen Tokyo–Kyoto–Osaka', en: 'Shinkansen tickets Tokyo–Kyoto–Osaka' },
      { id: 'Kendaraan privat untuk day trip Fuji', en: 'Private vehicle for the Fuji day trip' },
      { id: 'Hotel bintang 4 (termasuk sarapan)', en: '4-star hotels (breakfast included)' },
    ],
    excluded: [
      { id: 'Tiket pesawat internasional', en: 'International flights' },
      { id: 'Sewa kimono & tiket atraksi', en: 'Kimono rental & attraction tickets' },
      { id: 'Makan di luar program', en: 'Meals outside the program' },
    ],
  },
  {
    id: 'seoul-private',
    name: { id: 'Perjalanan Privat Seoul', en: 'Seoul Private Journey' },
    destination: { id: 'Korea Selatan', en: 'South Korea' },
    destinationSlug: 'south-korea',
    duration: { id: '5 hari 4 malam', en: '5 days 4 nights' },
    groupSize: { id: '2–8 orang', en: '2–8 people' },
    image: 'https://images.unsplash.com/photo-1602479185195-32f5cd203559?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxzb3V0aCUyMGtvcmVhJTIwc2VvdWx8ZW58MHx8fDE3OTE4NzUwNjF8MA&ixlib=rb-4.1.0&q=85',
    itinerary: [
      { id: 'Hari 1–2: Seoul — Gyeongbokgung dengan hanbok, Bukchon, Myeongdong.', en: 'Days 1–2: Seoul — Gyeongbokgung in hanbok, Bukchon, Myeongdong.' },
      { id: 'Hari 3: Day trip privat Pulau Nami & Garden of Morning Calm.', en: 'Day 3: Private day trip to Nami Island & Garden of Morning Calm.' },
      { id: 'Hari 4–5: Hongdae, N Seoul Tower, Sungai Han, belanja.', en: 'Days 4–5: Hongdae, N Seoul Tower, Han River, shopping.' },
    ],
    attractions: [
      { id: 'Istana Gyeongbokgung', en: 'Gyeongbokgung Palace' },
      { id: 'Pulau Nami', en: 'Nami Island' },
      { id: 'N Seoul Tower', en: 'N Seoul Tower' },
    ],
    included: [
      { id: 'Kendaraan privat + sopir', en: 'Private vehicle + driver' },
      { id: 'Hotel bintang 4 di pusat Seoul', en: '4-star hotel in central Seoul' },
      { id: 'Sewa hanbok satu hari', en: 'One-day hanbok rental' },
    ],
    excluded: [
      { id: 'Tiket pesawat', en: 'Flights' },
      { id: 'Belanja & pengeluaran pribadi', en: 'Shopping & personal expenses' },
      { id: 'Asuransi perjalanan', en: 'Travel insurance' },
    ],
  },
  {
    id: 'china-cultural',
    name: { id: 'Pengalaman Budaya China', en: 'China Cultural Experience' },
    destination: { id: 'China', en: 'China' },
    destinationSlug: 'china',
    duration: { id: '7 hari 6 malam', en: '7 days 6 nights' },
    groupSize: { id: '2–10 orang', en: '2–10 people' },
    image: 'https://images.unsplash.com/photo-1514920735211-8c697444a248?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxjaGluYSUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3OTE4NzUwNjB8MA&ixlib=rb-4.1.0&q=85',
    itinerary: [
      { id: 'Hari 1–3: Beijing — Kota Terlarang, Tembok Besar, Peking duck.', en: 'Days 1–3: Beijing — Forbidden City, Great Wall, Peking duck.' },
      { id: 'Hari 4–5: Xi\'an — Tentara Terakota & Muslim Quarter.', en: 'Days 4–5: Xi\'an — Terracotta Army & Muslim Quarter.' },
      { id: 'Hari 6–7: Shanghai — The Bund, Yu Garden, river cruise.', en: 'Days 6–7: Shanghai — The Bund, Yu Garden, river cruise.' },
    ],
    attractions: [
      { id: 'Tembok Besar China', en: 'Great Wall of China' },
      { id: 'Tentara Terakota', en: 'Terracotta Army' },
      { id: 'The Bund, Shanghai', en: 'The Bund, Shanghai' },
    ],
    included: [
      { id: 'Kereta cepat antar kota (kelas bisnis)', en: 'Intercity high-speed rail (business class)' },
      { id: 'Kendaraan privat + pemandu berbahasa Inggris/Indonesia', en: 'Private vehicle + English/Indonesian-speaking guide' },
      { id: 'Hotel bintang 4–5', en: '4–5-star hotels' },
    ],
    excluded: [
      { id: 'Tiket pesawat & visa China', en: 'Flights & China visa' },
      { id: 'Makan di luar program', en: 'Meals outside the program' },
      { id: 'Tips pemandu & sopir', en: 'Guide & driver tips' },
    ],
  },
  {
    id: 'maldives-escape',
    name: { id: 'Pelarian Pulau Maladewa', en: 'Maldives Island Escape' },
    destination: { id: 'Maladewa', en: 'Maldives' },
    destinationSlug: 'maldives',
    duration: { id: '4 hari 3 malam', en: '4 days 3 nights' },
    groupSize: { id: '2–4 orang', en: '2–4 people' },
    image: 'https://images.unsplash.com/photo-1602002418816-5c0aeef426aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxtYWxkaXZlcyUyMHJlc29ydHxlbnwwfHx8fDE3OTE4NzUwNjF8MA&ixlib=rb-4.1.0&q=85',
    itinerary: [
      { id: 'Hari 1: Speedboat ke resor, sunset pertama di water villa.', en: 'Day 1: Speedboat to the resort, first sunset in your water villa.' },
      { id: 'Hari 2: Snorkeling house reef & sandbank picnic.', en: 'Day 2: House reef snorkeling & sandbank picnic.' },
      { id: 'Hari 3: Spa, sunset dolphin cruise, romantic dinner.', en: 'Day 3: Spa, sunset dolphin cruise, romantic dinner.' },
      { id: 'Hari 4: Sarapan di atas laguna, kembali ke Malé.', en: 'Day 4: Breakfast over the lagoon, return to Malé.' },
    ],
    attractions: [
      { id: 'Water villa privat', en: 'Private water villa' },
      { id: 'House reef & pari manta', en: 'House reef & manta rays' },
      { id: 'Sandbank tengah samudra', en: 'Mid-ocean sandbank' },
    ],
    included: [
      { id: '3 malam di resor (beach/water villa)', en: '3 nights at a resort (beach/water villa)' },
      { id: 'Transfer speedboat pulang-pergi', en: 'Round-trip speedboat transfers' },
      { id: 'Sunset dolphin cruise & snorkeling gear', en: 'Sunset dolphin cruise & snorkeling gear' },
    ],
    excluded: [
      { id: 'Tiket pesawat ke Malé', en: 'Flights to Malé' },
      { id: 'Aktivitas diving & watersport', en: 'Diving & watersports activities' },
      { id: 'Minuman & pengeluaran resor lainnya', en: 'Drinks & other resort charges' },
    ],
  },
];
